/*eslint-disable*/
import React from "react";

function Footer() {
  return (
    <></>
    // <footer className={"footer" + (props.default ? " footer-default" : "")}>
    //   <Container fluid={props.fluid ? true : false}>
    //     <Row>
    //     </Row>
    //   </Container>
    // </footer>
  );
}


export default Footer;
